"use strict";
import React from "react";
import { observer } from "mobx-react";
const TileContainer = observer((props) => {
  return /* @__PURE__ */ React.createElement(
    "div",
    {
      className: "carousel__tile-container",
      style: {
        width: props.tileWidth
      }
    },
    props.getContent(props.contentIndex)
  );
});
export default TileContainer;
